export const parseImagePath = (imgData?: string): string | null => {
    try { return imgData ? JSON.parse(imgData).path || null : null; }
    catch { return null; }
};

export const getPriceText = (ticket: any, symbol: string): string => {
    const values = ticket.prices?.length
        ? ticket.prices.map((p: any) => Number(p.price))
        : [Number(ticket.price ?? 0)];
    const min = Math.min(...values);
    const max = Math.max(...values);
    return `${min === max ? max : `${min}-${max}`}${symbol}`;
};
